export default "__VITE_ASSET__B_Ixw$Cq__"